import { Component, OnInit } from '@angular/core';
import { BankDetails } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-proof-verification',
  templateUrl: './proof-verification.component.html',
  styleUrls: ['./proof-verification.component.scss']
})
export class ProofVerificationComponent implements OnInit {

  get isMultiBank(): boolean {
  const app = this.util.getCurrentApplicant;
    return !this.util.loanDetails.loanCommercialDetails.length && app.isSelfEmployed && app.loanBankConnectAccountsInfo.some((d: BankDetails) => !d.bankConfirmation);;
  };
  get proofTab():string{
    return this.util.getCache('kycTab');
  }
  bankDetailsText:string = '';

  constructor(public util:UtilService){}
  ngOnInit(): void {
    if(!this.proofTab){
      this.util.setCache('kycTab', 'bank');
    }
    if(!this.util.getCurrentApplicant?.mainApplicant){
      this.bankDetailsText = 'Co-applicant’s';
    }else{
      this.bankDetailsText = '';
    }
  }



  getInfo(val: string){
    switch (val) {
      case 'bank':
        return 'Confirm Applicants bank account';
      case 'aadhar':
        return 'OTP will be sent to the linked number';
      case 'selfie':
        return 'Make sure the face is clear and visible.';
      default: return '';
    }
  }

  goToHome(){
    this.util.route('home');
  }

}
